import { useCallback } from 'react';
import {
  FieldValues,
  Path,
  useFormContext,
  UseFormSetError
} from 'react-hook-form';

interface ApiErrorResponse {
  errors?: Record<string, string[]>;
}

const useFieldSetErrors = <TFieldValues extends FieldValues = FieldValues>(
  setError?: UseFormSetError<TFieldValues>
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const formContext = useFormContext<TFieldValues>();

  return useCallback(
    (error: ApiErrorResponse) => {
      const realSetError = setError || formContext?.setError;

      if (!realSetError) {
        return;
      }

      if (!error?.errors || typeof error.errors !== 'object') {
        return;
      }

      Object.keys(error.errors).forEach((name) => {
        const errorMessages = error.errors![name];
        if (Array.isArray(errorMessages) && errorMessages.length > 0) {
          realSetError(name as Path<TFieldValues>, {
            type: 'manual',
            message: errorMessages[0]
          });
        }
      });
    },
    [setError, formContext?.setError]
  );
};

export default useFieldSetErrors;
